import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { PublicAuthenticationStore } from '../stores/publicAuthenticationStore';

export const useAuthenticationStorePublic = () =>
  useContext<{
    authenticationStore: PublicAuthenticationStore;
  }>(StoreContext);
